import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  sidePanelClosed,
  sidePanelPinned,
  sidePanelUnpinned,
  signalingPinnedPanelsChanged,
} from 'features/side-panels/sidePanelsSlice';
import { signalingRoomJoined } from 'features/room/actions';
import { signalingFeatureEnabled, signalingFeatureDisabled } from 'features/feature-set/actions';
import { changePinnedPanelsSaga } from './changePinnedPanelsSaga';
import { onPinnedPanelsChangedSaga } from './onPinnedPanelsChangedSaga';
import { onRoomJoinedSaga } from './onRoomJoinedSaga';
import { reEvaluateAccessiblePinnedPanelsSaga } from './reEvaluateAccessiblePinnedPanelsSaga';

export default function* sidePanelsWatcher() {
  yield takeLatest([sidePanelPinned, sidePanelUnpinned, sidePanelClosed], changePinnedPanelsSaga);
  yield takeEvery(signalingPinnedPanelsChanged, onPinnedPanelsChangedSaga);
  yield takeEvery(signalingRoomJoined, onRoomJoinedSaga);
  yield takeEvery(
    [signalingFeatureEnabled, signalingFeatureDisabled],
    reEvaluateAccessiblePinnedPanelsSaga
  );
}
